import React, { useState } from 'react';
import { Link } from 'gatsby';
import {
    EuiButtonEmpty,
    EuiHeader,
    EuiHeaderSectionItemButton,
    EuiHeaderSections,
    EuiIcon,
    EuiPopover,
} from '@elastic/eui';
import headerLogo from '../../../images/hail-logo.png';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../stores';

export default observer(function Headers() {
    const {
        userStore: { logout, isLoggedIn },
    } = useStore();
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    function logoutClick() {
        // Close the popover
        setIsPopoverOpen(false);
        // Remove token, session storage, etc
        logout();
    }
    // Show empty placeholder
    function emptyHeaderSection(): EuiHeaderSections {
        return {
            items: [<></>],
            borders: 'none',
        };
    }
    function authenticatedLeftHeaderSection(): EuiHeaderSections {
        return {
            items: [
                <Link to="/home" state={{ local: true }}>
                    <EuiIcon type="home" size="m" color="black" />
                </Link>,
                <Link to="/bookings" state={{ local: true }} style={{ marginLeft: 16 }} title="Bookings">
                    <EuiIcon type="calendar" size="m" color="black" />
                </Link>,
            ],
            borders: 'none',
        };
    }
    function authenticatedRightHeaderSection(): EuiHeaderSections {
        return {
            items: [
                <EuiPopover
                    button={
                        <EuiHeaderSectionItemButton
                            aria-label="Account menu"
                            onClick={() => setIsPopoverOpen(isPopoverOpen => !isPopoverOpen)}
                            className="account-icon">
                            <EuiIcon type="user" size="m" color="black" />
                        </EuiHeaderSectionItemButton>
                    }
                    isOpen={isPopoverOpen}
                    closePopover={() => setIsPopoverOpen(false)}>
                    <EuiButtonEmpty onClick={logoutClick} iconType="exit">
                        Logout
                    </EuiButtonEmpty>
                </EuiPopover>,
            ],
            borders: 'none',
        };
    }
    return (
        <>
            <EuiHeader
                className="hail-app-admin-header"
                theme="dark"
                position="fixed"
                sections={[
                    isLoggedIn ? authenticatedLeftHeaderSection() : emptyHeaderSection(),
                    {
                        items: [
                            <Link className="header-logo" to={isLoggedIn ? '/home' : '/'} state={{ local: true }}>
                                <EuiIcon type={headerLogo} size="m" />
                            </Link>,
                        ],
                        borders: 'none',
                    },
                    isLoggedIn ? authenticatedRightHeaderSection() : emptyHeaderSection(),
                ]}
            />
        </>
    );
});
